import React from 'react';
interface Props {
  fillColor?: string;
}
function EarIcon({ fillColor = '#17385D' }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="17"
      viewBox="0 0 12 17"
      fill="none">
      <g clipPath="url(#clip0_847_3057)">
        <path
          d="M10.5 6.5C10.5 4.01562 8.48438 2 6 2C3.51562 2 1.5 4.01562 1.5 6.5V12C1.5 13.6562 2.84375 15 4.5 15C6.15625 15 7.5 13.6562 7.5 12C7.5 11.3219 7.84062 10.6688 8.43125 10.2875C9.67812 9.48438 10.5 8.0875 10.5 6.5ZM12 6.5C12 8.61875 10.9031 10.4812 9.24375 11.5469C9.09062 11.6469 9 11.8156 9 12C9 14.4844 6.98438 16.5 4.5 16.5C2.01562 16.5 0 14.4844 0 12V6.5C0 3.1875 2.6875 0.5 6 0.5C9.3125 0.5 12 3.1875 12 6.5ZM4 6.5V7.13125C4 7.225 4.05312 7.3125 4.1375 7.35625L4.575 7.575C5.14062 7.85938 5.49687 8.4375 5.49687 9.06875C5.49687 9.56563 5.27812 10.0344 4.89687 10.3531L3.72813 11.3281C3.40938 11.5938 2.9375 11.55 2.67188 11.2312C2.40625 10.9125 2.45 10.4406 2.76875 10.175L3.9375 9.2C3.975 9.16875 4 9.11875 4 9.06875C4 9.00313 3.9625 8.94375 3.90625 8.91562L3.46875 8.69687C2.875 8.4 2.5 7.79375 2.5 7.13125V6.5C2.5 4.56563 4.06563 3 6 3C7.93437 3 9.5 4.56563 9.5 6.5V6.75C9.5 7.16563 9.16562 7.5 8.75 7.5C8.33438 7.5 8 7.16563 8 6.75V6.5C8 5.39687 7.10313 4.5 6 4.5C4.89687 4.5 4 5.39687 4 6.5Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_847_3057">
          <rect
            width="12"
            height="16"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default EarIcon;
